import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap-v5';
import moment from 'moment';
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
import api from '../../services/Api';

interface IOperacao {
    id: number;
    criadoPor: number;
    usuarioNome?: string;
    esteiraId: number;
    relatorioId?: number;
    dataOperacao: string;
    tipo: string;
    processando: boolean;
    erro: boolean;
    processou: boolean;
    metadata?: string;
}

const tipoOperacaoMap: { [key: string]: string } = {
    'CONCILIATION': 'Conciliação',
    'MOVE_ALL': 'Mover todos',
};

function ModalHistoricoEsteira({ esteiraID, show, toggleModal }: { esteiraID: number, show: boolean, toggleModal: () => void }) {
    const { t } = useTranslation();
    const [historicoData, setHistoricoData] = useState<IOperacao[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        let interval: any;
        if (show && esteiraID) {
            const fetchHistorico = () => {
                setLoading(true);
                api.get<IOperacao[]>(`Esteira/${esteiraID}/operacoes`)
                    .then(res => {
                        setHistoricoData(res.data);
                        setLoading(false);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar histórico da esteira:", err);
                        setLoading(false);
                    });
            };

            fetchHistorico();
            interval = setInterval(fetchHistorico, 15000); // Atualiza a cada 15 segundos
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [show, esteiraID]);

    return (
        <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal">Histórico de Operações da Esteira</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                    </div>
                </div>
                <div className="modal-body">
                    {loading && <div>Carregando...</div>}
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {historicoData.map((item, index) => {
                            let statusText = "Pendente";
                            let statusColor = "gray";
                            if (item.processando) {
                                statusText = "Processando";
                                statusColor = "blue";
                            } else if (item.erro) {
                                statusText = "Erro";
                                statusColor = "red";
                            } else if (item.processou) {
                                statusText = "Concluído";
                                statusColor = "green";
                            }

                            let percentage = 0;
                            if (item.tipo === 'CONCILIATION' && item.metadata) {
                                try {
                                    const meta = JSON.parse(item.metadata);
                                    if (meta.TotalLancamentos > 0) {
                                        percentage = Math.round((meta.TotalProcessados / meta.TotalLancamentos) * 100);
                                        if (percentage > 100) percentage = 100;
                                    }
                                } catch (e) {
                                    console.error("Erro ao fazer parse do metadata:", e);
                                }
                            }

                            return (
                                <div key={index} style={{ padding: '10px', borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div>
                                            <span style={{ fontWeight: 'bold' }}>{tipoOperacaoMap[item.tipo] || item.tipo}</span>
                                            {item.tipo === 'CONCILIATION' && item.metadata && (
                                                <span style={{ fontSize: '12px', color: '#009ef7', marginLeft: '10px', fontWeight: 'bold' }}>
                                                    {percentage}%
                                                </span>
                                            )}
                                            {item.relatorioId && (
                                                <span style={{ fontSize: '11px', color: '#666', marginLeft: '10px' }}>
                                                    (Cartão ID: {item.relatorioId})
                                                </span>
                                            )}
                                        </div>
                                        <span style={{
                                            fontWeight: 'bold',
                                            color: statusColor,
                                            fontSize: '11px',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            backgroundColor: `${statusColor}22`
                                        }}>
                                            {statusText.toUpperCase()}
                                        </span>
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                                        <span>Usuário: {item.usuarioNome ? item.usuarioNome.split(' ').slice(0, 2).join(' ') : 'Desconhecido'}</span>
                                        <span style={{ float: 'right' }}>{moment(item.dataOperacao).format("DD/MM/YYYY HH:mm:ss")}</span>
                                    </div>
                                </div>
                            );
                        })}
                        {historicoData.length === 0 && !loading && (
                            <div style={{ textAlign: 'center', padding: '20px', color: 'gray' }}>
                                Nenhuma operação encontrada para esta esteira.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ModalHistoricoEsteira;
